import { useState, type FormEvent } from "react";
import { Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface Props {
  /** The applied reference, or undefined when not searching. */
  value?: string;
  onChange: (reference: string | undefined) => void;
}

/** Search by the network's id (IdentificativoSdI for SDI). On submit only: a partial id matches nothing. */
export function EInvoiceReferenceSearch({ value, onChange }: Props) {
  const [text, setText] = useState(value ?? "");

  function submit(e: FormEvent) {
    e.preventDefault();
    const trimmed = text.trim();
    onChange(trimmed.length > 0 ? trimmed : undefined);
  }

  function clear() {
    setText("");
    onChange(undefined);
  }

  return (
    <form onSubmit={submit} className="flex w-full max-w-sm items-center gap-2">
      <div className="relative flex-1">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 size-3.5 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="SDI / network id"
          aria-label="Find by network id"
          className="h-8 pl-8"
        />
      </div>
      <Button type="submit" size="sm" variant="outline">
        Find
      </Button>
      {value && (
        <Button type="button" size="icon" variant="ghost" className="size-8" onClick={clear} aria-label="Clear search">
          <X className="size-3.5" />
        </Button>
      )}
    </form>
  );
}
